import { ref } from 'vue';
import DocumentRepository from '@/repositories/document/DocumentRepository.ts';
import {
    Document,
    DocumentCreateForm,
    DocumentCreateRequestResult,
    mapDocumentCreateFormToFormData,
} from '@/types/document';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useDocumentRepository() {
    const arDocuments = ref<Document[]>([]);
    const documentRepository = new DocumentRepository();

    function getDocuments(): void {
        documentRepository.getDocuments().then((documents: Document[]) => {
            arDocuments.value = documents;
        });
    }

    function createDocument(form: DocumentCreateForm): Promise<void> {
        return documentRepository.createDocument(
            mapDocumentCreateFormToFormData(form),
        );
    }

    function createDocuments(forms: DocumentCreateForm[]): Promise<DocumentCreateRequestResult[]> {
        return new Promise((resolve) => {
            Promise.all(
                forms.map((form: DocumentCreateForm) => createDocument(form).catch((errors) => errors)),
            )
                .then((results) => {
                    const formResults: DocumentCreateRequestResult[] = [];

                    forms.forEach((form: DocumentCreateForm, index: number) => {
                        formResults.push({
                            form: form,
                            errors: results[index],
                        });
                    });

                    resolve(formResults);
                });
        });
    }

    function deleteDocument(id: number): Promise<void> {
        return documentRepository.deleteDocument(id);
    }

    return {
        arDocuments,
        getDocuments: getDocuments,
        createDocument: createDocument,
        createDocuments: createDocuments,
        deleteDocument: deleteDocument,
    };
}
